import { AuthUser } from 'aws-amplify/auth';
import { create } from 'zustand';

interface AuthStore {
    user: AuthUser | undefined;
    isUserSet: boolean;
    userEmail: string;
    reset: () => void;
}

const initialState = {
    user: undefined,
    isUserSet: false,
    userEmail: '',
};

export const useAuthStore = create<AuthStore>((set) => ({
    ...initialState,
    reset: (): void => set({ ...initialState }),
}));
